<template>
  <LayoutEmpty>
      <div
              class="container"
              id="subscribe"
              ref="scrollOnNewCodeElement"
      >
        <section class="main">
          <div class="girl-container"></div>
          <div class="content-container">
            <div class="content">
              <router-link :to="{name: 'home'}">
                <div class="logo"></div>
              </router-link>
              <div class="subscription-container failable loadable" :class="{failed: countries.error || purchaseOptions.error, loading: countries.loading || purchaseOptions.loading || fullLoading}">
                <template v-if="!countries.error && !countries.loading">
                  <!--<div
                          class="country form-group"
                  >
                      <label>
                          {{$t('subscription.country.label')}}
                      </label>
                      <select
                              class="form-control"
                              :title="$t('subscription.country.label')"
                              v-model="selectedCountry"
                      >
                          <option :value="null">
                              {{$t('subscription.country.international')}}
                          </option>
                          <option
                                  v-for="country in countries.data"
                                  :key="country.id"
                                  :value="country"
                          >
                              {{country.name}}
                          </option>
                      </select>
                  </div>-->
                    <SubscriptionForm
                            v-if="!purchaseOptions.error && !purchaseOptions.loading"
                            :selected-country="selectedCountry"
                            :purchase-options="purchaseOptions.data"
                            :show-currency="showCurrency"
                            @loadingChange="fullLoading = $event"
                            :code="promotionalCode"
                            :referal="referalCode"
                            @purchaseOptionSelectedChanged="purchaseOptionSelectedChangedHandler"
                    />
                </template>
                <div class="failed-wrapper">
                  <p class="error" v-if="countries.error">
                    {{$t('error')}}
                    <br>
                    <button type="button" @click="loadCountries">
                      {{$t('retry')}}
                    </button>
                  </p>
                  <p class="error" v-if="purchaseOptions.error">
                    {{$t('error')}}
                    <br>
                    <button type="button" @click="loadPurchaseOptions">
                      {{$t('retry')}}
                    </button>
                  </p>
                </div>
                <div class="loader-wrapper">
                  <Spinner/>
                </div>
              </div>
              <form
                      v-show="!promotionalCodeHidden"
                      v-if="!countries.error && !countries.loading"
                      class="promotional-code-form"
                      @submit.prevent="enterPromotionalCode"
                      @click="$refs.codeInput.focus()"
                      @mouseenter="$refs.codeInput.focus()"
              >
                <label>
                  {{$t('subscription.promotional_code.call_to_action.use')}}
                </label>
                <input ref="codeInput" type="text" :class="{'not-empty': !!promotionalCodeTyped}" v-model="promotionalCodeTyped"/>
              </form>
            </div>
          </div>
        </section>
        <section class="disclaimers">
          <router-link :to="{name: 'home'}">
            <div class="logo"></div>
          </router-link>
          <h4>
            * {{$t('subscription.payment_legals.title')}}
          </h4>
          <div class="list" v-if="showCurrency">
            <PurchaseOptionLegals
                    :show-currency="showCurrency"
                    :purchase-option="purchaseOption"
                    :key="purchaseOption.id"
                    v-for="purchaseOption in purchaseOptions.data"
                    :include-option-description="true"
            />
            <p class="currency-disclaimer">
              {{$t('subscription.currency_disclaimer', {currency_description: showCurrency.description, currency_code: showCurrency.code, currency_symbol: showCurrency.symbol})}}
            </p>
            <p
              v-if="upgrade"
              class="currency-disclaimer"
            >
              {{$t('subscription.upgrade_disclaimer')}}
            </p>
          </div>
        </section>
      </div>
      <Footer/>
  </LayoutEmpty>
</template>

<script>
  import SubscriptionForm from "../components/SubscriptionForm";
  import PurchaseOptionLegals from "../components/PurchaseOptionLegals";
  import Footer from "../components/Footer";
  import LayoutEmpty from "../layouts/LayoutEmpty";
  import Spinner from "../components/Spinner";
  import resources from '../resources';

  let promotionalCodeTypedTimeout = null;

    export default {
      components: {
        PurchaseOptionLegals,
        SubscriptionForm,
        Footer,
        LayoutEmpty,
        Spinner,
      },
      data(){
        return {
          promotionalCodeTyped: this.$route.query.code || '',
          promotionalCodeEntered: this.$route.query.code || '',
          suscriptionPlanIdEntered: this.$route.query.plan || '',
          webstarIdEntered: this.$route.query.webstar || '',
          purchaseOptionSelected: null,
          countries: {
            data: [],
            loading: true,
            error: false,
          },
          purchaseOptions: {
            data: [],
            loading: true,
            error: false,
          },
          fullLoading: false,
          selectedCountry: null,
          internationalCurrency: null,
          upgrade: false,
        }
      },
      computed: {
        referalCode(){
          return this.$route.query.ref || null;
        },
        showCurrency(){
          return this.selectedCountry ? this.selectedCountry.show_currency.data : this.internationalCurrency;
        },
        promotionalCode(){
          return this.promotionalCodeEntered || this.$route.query.code || null;
        },
        promotionalCodeHidden(){
          return this.$route.query.code || this.purchaseOptionSelected || this.referalCode || this.suscriptionPlanIdEntered || this.webstarIdEntered;
        }
      },
      methods: {
          purchaseOptionSelectedChangedHandler(purchaseOptionSelected){
            this.purchaseOptionSelected = purchaseOptionSelected;
          },
          enterPromotionalCode(){
            this.promotionalCodeEntered = this.promotionalCodeTyped;

            window.scrollTo(0, this.$refs.scrollOnNewCodeElement.offsetTop);
          },
          loadPurchaseOptions(){
              this.purchaseOptions.data = [];
              this.purchaseOptions.error = false;
              this.purchaseOptions.loading = true;

              resources.purchaseOptions.index({
                country_id: this.selectedCountry ? this.selectedCountry.id : 'INT',
                include: ['subscription_plan.payment_methods', 'subscription_plan.onward_subscription_plan', 'subscription_plan.one_click_pay_cards'],
                code: this.promotionalCode,
                referal: this.referalCode,
                plan: this.suscriptionPlanIdEntered,
                webstar: this.webstarIdEntered,
              })
                .then((response) => {
                    this.purchaseOptions.loading = false;
                    this.purchaseOptions.data = response.data.data;
                    this.checkAlreadySubscribed();
                }).catch((err) => {
                    this.purchaseOptions.loading = false;
                    this.purchaseOptions.error = true;
                })
          },
          loadCountries(){
            this.countries.data = [];
            this.countries.loading = true;
            this.countries.error = false;

            Promise.all([
              resources.countries.index({payable: 1, per_page: 999, include: ['is_current', 'show_currency'],}),
              resources.currencies.index({default: 1}), //Es para traer la default para el "internacional", despues cada pais trae su moneda o la default
            ])
            .then(([countriesResponse, currencyResponse]) => {
              this.internationalCurrency = currencyResponse.data.data[0];
              this.countries.data = countriesResponse.data.data;
              this.countries.loading = this.countries.error = false;
              this.selectedCountry = this.countries.data.find(country => country.is_current === true) || null;
              this.loadPurchaseOptions();

              if(!this.internationalCurrency) {
                return this.countries.error = true;
              }
            }).catch((err) => {
              this.countries.loading = false;
              this.countries.error = true;
            });
          },
          checkAlreadySubscribed(){
            let upgrade   = false;
            let redirect  = false;
            this.purchaseOptions.data.forEach(purchaseOption => {
              if (purchaseOption.promotional_code && purchaseOption.promotional_code.data.type_is_pre_paid) console.log('continue');
              let followingModelType = purchaseOption.subscription_plan.data.current_status;
              // console.log(followingModelType);
              if (followingModelType === 'normal' && purchaseOption.subscription_plan.data.premium ) upgrade = true
              if (followingModelType === 'premium' ) redirect = true
            });
            // console.log({upgrade}, {redirect})
            if(redirect) this.$router.push({name: 'home'});
            if(upgrade) this.upgrade = true;
          }
      },
      watch: {
        selectedCountry(){
            this.loadPurchaseOptions();
        },
        promotionalCodeTyped(codeTyped){
          if(promotionalCodeTypedTimeout){
            clearTimeout(promotionalCodeTypedTimeout);
          }

          if(!codeTyped){
            this.enterPromotionalCode();
          }else{
            promotionalCodeTypedTimeout = setTimeout(() => {
              if(this.promotionalCode !== codeTyped){
                this.enterPromotionalCode();
              }
            }, 1000);
          }
        },
        promotionalCode(){
          if(!this.countries.error || !this.countries.loading){
            this.loadPurchaseOptions();
          }
        }
      },
      mounted(){
        this.loadCountries();
      }
    }
</script>

<style scoped lang="scss">
  @import '../styles/variables';
  @import '../styles/classes';

  #subscribe {
    background-color: $pallete_dark_color;
    color: $pallete_clear_text_color;
    display: flex;
    flex-direction: column;
    padding: 1em;

    .error{
      text-align: center;
    }

    .subscription-container{
      min-height: 400px;
    }

    section.main{
      display: flex;
      justify-content: space-around;
      position: relative;

      .girl-container{
        flex: 1;
        background-image: url('/img/subscribe_girl.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center right;
        z-index: 0;
        max-height: 100vh;
        min-height: 500px;

        @media(max-width: 980px){
          position: absolute;
          left: -200px;
          width: 400px;
          height: 100%;

          background-position: center center;
        }

        @media(max-width: 600px){
          left: 0;
          width: 100%;
          height: 100%;
          min-height: auto;
          max-height: inherit;
          background-position: center center;
          opacity: .35;
        }
      }

      .content-container{
        position: relative;
        z-index: 1;
        flex: 1.5;
        padding: 120px 0;

        @media(max-width: 980px){
          padding-left: 20%;
        }

        @media(max-width: 600px){
          padding-left: 0;
          padding-top: 2em;

          .logo{
            height: 30px;
          }
        }

        @media(max-height: 750px){
          min-height: 100vh;
        }

        .content{
          min-height: 350px;
          width: 500px;
          margin: auto;

          .logo{
            display: block;
            margin: auto;
            margin-bottom: 50px;
            height: 50px;
            width: 100%;
            background-image: url('/img/logo-white.png');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
          }

          @media(max-width: 600px){
            width: 100%;
            font-size: .9em;
          }
        }
      }
    }

    section.features{
      display: flex;
      flex-wrap: wrap;
      margin: 1em 0;
      justify-content: space-around;

      article{
        flex-basis: 25%;

        @media(max-width: 1200px){
          flex-basis: 30%
        }

        @media(max-width: 900px){
          flex-basis: 100%;
        }

        .header{
          background-color: $pallete_main_color;
          color: $pallete_clear_text_color;
          margin-bottom: .5em;
          padding: .5em .25em;
          text-align: center;
          text-transform: uppercase;
          font-size: .9em;
        }

        .image{
          height: 180px;
          background-size: cover;
          background-position: center center;

          @media(max-width: 900px){
            height: 50vw;
          }
        }
      }
    }

    section.disclaimers{
      display: block;
      text-align: center;
      margin-top: 2em;
      margin-bottom: 2em;

      .logo{
        display: block;
        margin: auto;
        height: 50px;
        width: 100%;
        background-image: url('/img/logo-white.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        margin-bottom: 50px;
      }

      .list{
        font-size: 1em;
        font-weight: bold;
      }
    }

    .promotional-code-form{
      @extend %fresh-btn;
      max-width: 15em;
      display: block;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      padding: .25em 1.5em;
      font-size: 1.5em;
      position: relative;

      label{
        font-size: .75em;
      }

      input{
        display: block;
        transition: height .33s ease;
        height: 0;
        margin: 0;
        width: 100%;
        text-transform: uppercase;
        color: #ffffff;
        font-size: 1.25em;
        border: none;
        background-color: transparent;

        &.not-empty, &:focus{
          outline: none;
          height: 1.25em;
        }
      }
    }
  }
</style>
